import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as SrlC from "./_ccbSrlC";
import { a } from "./_cmABT";
import * as _cr from "./_cr";
import { useMdlz } from "./_csMdl";
import * as _hm from "./_hm";
import * as _ht from "./_ht";

export const useMdlPcrz = () => {
  const _sMdlz = useMdlz();
  const _show = (pz: {
    ls?: _ht.ls,
    onPrs: ( _dz: _ht.dz ) => void,
  }) => {
    const _dw = _cr.d('p') ? 60 : 40;
    //_hm.l(`17: ${_hm.s(pz.ls)}`)
    const _ls = (
      _cr.c(BoxC.N, {
        key: -10,
        boxStlz: a(`br/1 dw/${_dw} dhx/70 fd/csc p/1 sc/lt1`),
        boxClds: 
        [
          _cr.c(SrlC.N, {
            srlStlz: {
              otrz: a(`dh/f`),
            },
            srlClds:
              pz.ls?.map((_dz: _ht.dz, _idx: _ht.n) => {
                return (
                  _cr.c(BtnC.N, {
                    key: _idx,
                    lblCz: {
                      text: _dz.text,
                      textPtyz: a(`tn/1`),
                    },
                    frmCz: {
                      boxStlz: a(`bc/lt5 bs/ds bwt/${_idx == 0 ? 0 : 0.5} fd/rcc dw/${_dw - 2} pv/1 ph/1`),
                      pslPtyz: {
                        onPrs: () => {
                          if (pz.onPrs) pz.onPrs(_dz);
                          _sMdlz.set({
                            bShow: false,
                          });
                        },
                      },
                    }
                  })
                )
              })
          })
        ]
      })
    );
    _sMdlz.set({
      bShow: true,
      mdlClds: _ls
    })
  }
  return {
    show: _show
  }
};
